import { LOGIN, POST_OTP, CHECK_OTP } from '../constant'
import axios from 'axios'
import EventEmitter from 'events'

const localStorageKey = 'loggedIn'
const tokenExpiryKey = 'tokenExpiry'
const loginEvent = 'loginEvent'

class AuthService extends EventEmitter {
  login(body) {
    let config_token = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('token'),
      },
    }
    //
    return axios.post(LOGIN, body, config_token)
  }

  sendOtp(body) {
    let config_token = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('token'),
      },
    }
    //
    return axios.post(POST_OTP, body, config_token)
  }

  checkOtp(body) {
    let config_token = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('token'),
      },
    }
    //
    return axios.post(CHECK_OTP, body, config_token)
  }

  setStorageLogin(authResult, token, monthly_change = false) {
    localStorage.setItem('token', token)
    let d = new Date()
    let n = d.getTime()

    let tokenExpiry = new Date(n + 36000 * 1000)

    localStorage.setItem(tokenExpiryKey, JSON.stringify(tokenExpiry.getTime()))
    localStorage.setItem(localStorageKey, 'true')

    // localStorage.setItem("menu", JSON.stringify(authResult.role));
    localStorage.setItem(
      'userData',
      JSON.stringify({
        displayName: authResult.FirstName + ' ' + authResult.LastName,
        email: authResult.EmailPersonal,
        photoURL: '/tmp',
        providerId: 0,
        uid: authResult.FirstName,
        monthly_change: monthly_change,
      })
    )

    this.emit(loginEvent, {
      loggedIn: true,
      profile: token,
      state: authResult.appState || {},
    })
  }

  renewTokens(val) {
    // reject can be used as parameter in promise for using reject
    return new Promise((resolve) => {
      if (localStorage.getItem(localStorageKey) !== 'true') {
        // return reject("Not logged in");
      }
      this.setStorageLogin(authResult)
    })
  }

  logOut() {
    //
    localStorage.removeItem(localStorageKey)
    localStorage.removeItem(tokenExpiryKey)
    localStorage.removeItem('userInfo')
    localStorage.removeItem('token')
    localStorage.removeItem('userData')
    localStorage.removeItem('userRole')

    this.idToken = null
    this.tokenExpiry = null
    this.profile = null
    this.emit(loginEvent, { loggedIn: false })
    // setTimeout(()=>{
    //     location.reload();
    // },500)
  }

  isAuthenticated() {
    return (
      new Date(Date.now()) <
        new Date(JSON.parse(localStorage.getItem(tokenExpiryKey))) &&
      localStorage.getItem(localStorageKey) === 'true'
    )
  }
}

export default new AuthService()
